import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import icInfo from './ic_info.svg';
import { FormattedMessage } from 'react-intl';

export default class SendCodOtp extends React.Component {
  static propTypes = {
    maskedPhoneNumber: PropTypes.string.isRequired,
  };

  render() {
    const { maskedPhoneNumber } = this.props;

    return (
      <div className="pill-container">
        <div className="pill-top">
          <img src={icInfo} alt="" className="pill-icon" />
          <span><FormattedMessage id="GoSend.COD.returnOtpTitle" /></span>
        </div>
        <div className="pill-bottom">
          <span className="pill-part">
            <FormattedMessage id="GoSend.COD.returnOtpInstructionOne" />
          </span>
          <span className="pill-part">{maskedPhoneNumber}</span>
          <span className="pill-part">
            <FormattedMessage id="GoSend.COD.returnOtpInstructionTwo" />
          </span>
        </div>
      </div>
    );
  }
}
